module.exports = __webpack_public_path__ + "static/booking-1-8242a95de720b5319aae3fbf2b1e95b7.svg";